<div class="menubar-link">
  <ul class="slidein section">
    <li>
      <button type="button" onclick="window.location.href='services'" ><span data-hover="Our Services">Our Services</span></button>
    </li>
    <li>
      <button type="button" onclick="window.location.href='about-us'" ><span data-hover="About us">About us</span></button>
    </li>
    <li>
      <button type="button" onclick="window.location.href='contact-us'" ><span data-hover="Contact us">Contact us</span></button>
    </li>

  </ul>
  <button class="text-white closeMenu "><span class="icon-xmark"></span></button>
</div>
